import { initializeApp } from "firebase/app";
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
} from "firebase/messaging";

(function () {
  let chConfig = {};
  let currentScript = document.currentScript;
  let CARTHIKE_ENV = getParameterByName("environment", currentScript.src);

  let firebaseConfig = {};
  let proxyPath = "";
  let serviceWorkerRegistration;

  let CARTHIKE_SERVER_URL = "http://localhost:3333";
  let VAPID_KEY = "";
  if (CARTHIKE_ENV === "dev") {
    CARTHIKE_SERVER_URL = "https://localhost";
    firebaseConfig = {
      apiKey: "AIzaSyDnUQZQ_YK515ZSwDOI_STdh-BZ7owcfu8",
      authDomain: "whatscart-local.firebaseapp.com",
      databaseURL: "https://whatscart-local.firebaseio.com",
      projectId: "whatscart-local",
      storageBucket: "whatscart-local.appspot.com",
      messagingSenderId: "539746952025",
      appId: "1:539746952025:web:4cf1061d8647b5946a6248",
      measurementId: "G-GCFX7SNSY3",
    };
    VAPID_KEY =
      "BAVT2wur5k0ZsyQI3vdoLXfBOmGtJDSLIn-phoD_ItkFYeIQgEWG1YV7213zS-1ocpsKO2C6xrW1U3RFyMt754I";
    proxyPath = "pushhike-dev";
  } else if (CARTHIKE_ENV === "staging") {
    CARTHIKE_SERVER_URL = "https://pushhikestaging.carthike.com";
    firebaseConfig = {
      apiKey: "AIzaSyDnUQZQ_YK515ZSwDOI_STdh-BZ7owcfu8",
      authDomain: "whatscart-local.firebaseapp.com",
      databaseURL: "https://whatscart-local.firebaseio.com",
      projectId: "whatscart-local",
      storageBucket: "whatscart-local.appspot.com",
      messagingSenderId: "539746952025",
      appId: "1:539746952025:web:4cf1061d8647b5946a6248",
      measurementId: "G-GCFX7SNSY3",
    };
    VAPID_KEY =
      "BAVT2wur5k0ZsyQI3vdoLXfBOmGtJDSLIn-phoD_ItkFYeIQgEWG1YV7213zS-1ocpsKO2C6xrW1U3RFyMt754I";
    proxyPath = "pushhike-staging";
  } else if (CARTHIKE_ENV === "prod") {
    CARTHIKE_SERVER_URL = "https://pushhike.carthike.com";
    firebaseConfig = {
      apiKey: "AIzaSyCRLnxgRaepIic6uIm3HvOnRSByEdBCJTU",
      authDomain: "whatscart-production.firebaseapp.com",
      databaseURL: "https://whatscart-production-default-rtdb.firebaseio.com",
      projectId: "whatscart-production",
      storageBucket: "whatscart-production.appspot.com",
      messagingSenderId: "186979113434",
      appId: "1:186979113434:web:55ea0353f4a7bb9ed588e3",
      measurementId: "G-FF5FS8X6NH",
    };
    VAPID_KEY =
      "BOnaHInMPNbMmOoZT7gSIeCZb__9Apa9LzSUY0vc7p_0XfPjAhhSHc_CZgh971LHPX63CMyhLkN869KBEFZC4WY";
    proxyPath = "pushhike";
  }

  const app = initializeApp(firebaseConfig);

  const messaging = getMessaging(app);
  onMessage(messaging, (payload) => {
    console.log("[Pushhike] Received foreground message ", payload);
    serviceWorkerRegistration.showNotification(payload.data.title, payload);
  });

  function registerServiceWorker() {
    const shopOrigin = getParameterByName("shop", currentScript.src);
    const url =
      window.location.origin +
      `/apps/${proxyPath}/service-worker.js?shop=${shopOrigin}&environment=${CARTHIKE_ENV}`;
    navigator.serviceWorker.register(url).then(
      (reg) => {
        let serviceWorker;
        serviceWorkerRegistration = reg;
        if (reg.installing) {
          serviceWorker = reg.installing;
          // console.log('Service worker installing');
        } else if (reg.waiting) {
          serviceWorker = reg.waiting;
          // console.log('Service worker installed & waiting');
        } else if (reg.active) {
          serviceWorker = reg.active;
          // console.log('Service worker active');
        }

        if (serviceWorker) {
          console.log("sw current state", serviceWorker.state);
          if (serviceWorker.state == "activated") {
            //If push subscription wasnt done yet have to do here
            console.log("sw already activated - Do watever needed here");
            enableMessaging(reg);
          }
          serviceWorker.addEventListener("statechange", function (e) {
            console.log("sw statechange : ", e.target.state);
            if (e.target.state == "activated") {
              // use pushManger for subscribing here.
              console.log(
                "Just now activated. now we can subscribe for push notification"
              );
              enableMessaging(reg);
            }
          });
        }
      },
      (err) => {
        console.error("unsuccessful registration with ", workerFileName, err);
      }
    );
  }

  async function enableMessaging(registeration) {
    try {
      const isMessagingSupported = await isSupported();
      if (isMessagingSupported) {
        const messaging = getMessaging(app);
        getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: registeration,
        })
          .then((currentToken) => {
            if (currentToken) {
              console.log("current token", currentToken);
              syncToken(currentToken);
            } else {
              // Show permission request UI
              console.log(
                "No registration token available. Request permission to generate one."
              );
              // ...
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
            // ...
          });
      }
    } catch (error) {
      console.log("mesaging not initialized", error);
    }
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function pushhike_injectCss(css) {
    /** @type {Element} */
    var style = document.createElement("style");
    /** @type {string} */
    style.type = "text/css";
    /** @type {string} */
    style.rel = "stylesheet";
    style.media = "all";
    try {
      /** @type {string} */
      style.styleSheet.cssText = css;
    } catch (t) {}
    try {
      /** @type {string} */
      style.innerHTML = css;
    } catch (t) {}
    document.getElementsByTagName("head")[0].appendChild(style);
  }

  var OC_DOM = new (function () {
    var IS_READY = false;
    var CALLBACKS = [];
    var SELF = this;

    SELF.ready = function (callback) {
      //check to see if we're already finished
      if (IS_READY === true && typeof callback === "function") {
        callback();
        return;
      }

      //else, add this callback to the queue
      CALLBACKS.push(callback);
    };
    var addEvent = function (event, obj, func) {
      if (window.addEventListener) {
        obj.addEventListener(event, func, false);
      } else if (document.attachEvent) {
        obj.attachEvent("on" + event, func);
      }
    };
    var doScrollCheck = function () {
      //check to see if the callbacks have been fired already
      if (IS_READY === true) {
        return;
      }

      //now try the scrolling check
      try {
        document.documentElement.doScroll("left");
      } catch (error) {
        setTimeout(doScrollCheck, 1);
        return;
      }

      //there were no errors with the scroll check and the callbacks have not yet fired, so fire them now
      fireCallbacks();
    };
    var fireCallbacks = function () {
      //check to make sure these fallbacks have not been fired already
      if (IS_READY === true) {
        return;
      }

      //loop through the callbacks and fire each one
      var callback = false;
      for (var i = 0, len = CALLBACKS.length; i < len; i++) {
        callback = CALLBACKS[i];
        if (typeof callback === "function") {
          callback();
        }
      }

      //now set a flag to indicate that callbacks have already been fired
      IS_READY = true;
    };
    var listenForDocumentReady = function () {
      //check the document readystate
      if (document.readyState === "complete") {
        return fireCallbacks();
      }

      //begin binding events based on the current browser
      if (document.addEventListener) {
        addEvent("DOMContentLoaded", document, fireCallbacks);
        addEvent("load", window, fireCallbacks);
      } else if (document.attachEvent) {
        addEvent("load", window, fireCallbacks);
        addEvent("readystatechange", document, fireCallbacks);

        //check for the scroll stuff
        if (document.documentElement.doScroll && window.frameset === null) {
          doScrollCheck();
        }
      }
    };

    //since we have the function declared, start listening
    listenForDocumentReady();
  })();

  function getCarthikeConfig(shop) {
    return fetch(
      CARTHIKE_SERVER_URL + "/api/widget/public/config?shop=" + shop
    ).then((response) => {
      return response.json();
    });
  }

  function processCarthikeConfig(config) {
    if (config) {
      switch (config.promptType) {
        case "browser":
          registerServiceWorker();
          break;
        case "custom":
          console.log("custom prompt yet to be added");
          renderCustomPrompt(config);
          break;
        case "none":
          break;
        default:
          break;
      }
      detectCartChangesUsingXML(syncABC);
      detectCartChangesUsingFetch(syncABC);
      initSyncCart();
    }
  }

  //simple use case
  OC_DOM.ready(function () {
    // createIframe();

    if (currentScript.src) {
      var shopOrigin = getParameterByName("shop", currentScript.src);

      if (shopOrigin) {
        getCarthikeConfig(shopOrigin).then((response) => {
          chConfig = response.config;
          processCarthikeConfig(response.config);
        });
      }
    }
  });

  document.addEventListener("DOMContentLoaded", function (event) {});

  function CH_isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  function updateChAnalyticEvent(event) {
    var shopOrigin = getParameterByName("shop", currentScript.src);
    return fetch(
      CARTHIKE_SERVER_URL + "/api/chat/analytics/add?shop=" + shopOrigin,
      {
        method: "POST",
        body: JSON.stringify({ event }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  function syncToken(subscriberToken) {
    const browser = getBrowserName();
    const userAgent = navigator.userAgent;
    const sessionToken = getOrCreateToken();
    const language = window.navigator.language;
    const timezone = getTimezone();
    const os = getOSName();
    const deviceUsed = getDeviceType();
    var shopOrigin = getParameterByName("shop", currentScript.src);

    return fetch(
      CARTHIKE_SERVER_URL + "/api/subscriber/add?shop=" + shopOrigin,
      {
        method: "POST",
        body: JSON.stringify({
          browser,
          userAgent,
          sessionToken,
          language,
          timezone,
          subscriberToken,
          os,
          deviceUsed,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  function getOrCreateToken() {
    const token = localStorage.getItem("pushhike_token");
    if (token) {
      return token;
    }
    const newToken = getSessionToken();
    localStorage.setItem("pushhike_token", newToken);
    return newToken;
  }

  function getTimezone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      return null;
    }
  }
  function getOSName() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Win")) {
      return "Windows";
    } else if (userAgent.includes("Mac")) {
      return "MacOS";
    } else if (userAgent.includes("Linux")) {
      return "Linux";
    } else if (userAgent.includes("Android")) {
      return "Android";
    } else if (userAgent.includes("iOS")) {
      return "iOS";
    } else {
      return "Unknown OS";
    }
  }
  function getDeviceType() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("iPhone")) {
      return "iPhone";
    } else if (userAgent.includes("iPad")) {
      return "iPad";
    } else if (userAgent.includes("Android")) {
      if (userAgent.includes("Mobile")) {
        return "Android Mobile";
      } else {
        return "Android Tablet";
      }
    } else if (userAgent.includes("Windows Phone")) {
      return "Windows Phone";
    } else if (userAgent.includes("Mac")) {
      return "Mac";
    } else if (userAgent.includes("Windows")) {
      return "Windows PC";
    } else if (userAgent.includes("Linux")) {
      return "Linux PC";
    } else {
      return "Unknown Device";
    }
  }

  function getSessionToken() {
    const length = 16;
    const timestamp = new Date().getTime().toString(36);
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;

    const randomBytes = new Uint8Array(length);
    window.crypto.getRandomValues(randomBytes);

    let randomPart = "";
    for (let i = 0; i < length; i++) {
      randomPart += characters[randomBytes[i] % charactersLength];
    }

    return timestamp + randomPart;
  }

  function getBrowserName() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Chrome")) {
      return "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
      return "Mozilla Firefox";
    } else if (userAgent.includes("Safari")) {
      return "Apple Safari";
    } else if (userAgent.includes("Edge")) {
      return "Microsoft Edge";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      return "Opera";
    } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
      return "Internet Explorer";
    } else {
      return "Unknown Browser";
    }
  }

  function detectCartChangesUsingXML(callback) {
    const open = window.XMLHttpRequest.prototype.open;

    function openReplacement() {
      this.addEventListener("load", function () {
        if (
          [
            "/cart/add.js",
            "/cart/update.js",
            "/cart/change.js",
            "/cart/clear.js",
          ].includes(this._url)
        ) {
          callback(this.response);
        }
      });
      return open.apply(this, arguments);
    }

    window.XMLHttpRequest.prototype.open = openReplacement;
  }

  function detectCartChangesUsingFetch(callback) {
    var fetch = window.fetch;

    window.fetch = function () {
      var url = arguments.length <= 0 ? void 0 : arguments[0];
      var app =
        "string" == typeof url
          ? url
          : url instanceof URL
          ? url.pathname
          : url instanceof Request
          ? url.url
          : "";
      var nodeRequest = (arguments.length <= 1 ? void 0 : arguments[1]) || {};
      var method = nodeRequest.method || "GET";
      var result = fetch(...arguments);
      return (
        (("GET" === method && app.includes("/cart/add")) ||
          ("POST" === method &&
            (app.includes("/cart/add") ||
              app.includes("/cart/update") ||
              app.includes("/cart/change")))) &&
          result.then(async (response) => {
            const res = await response.clone().json();
            callback(res);
          }),
        result
      );
    };
  }

  function sendCartToServer(cart) {
    var shopOrigin = getParameterByName("shop", currentScript.src);
    return fetch(CARTHIKE_SERVER_URL + "/api/cart/add?shop=" + shopOrigin, {
      method: "POST",
      body: JSON.stringify({ cart }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function syncABC(cartResponse) {
    console.log("cart added sync it to server", cartResponse);
    if (cartResponse && cartResponse.token) {
      if (isPermissionGranted()) {
        const sessionToken = getOrCreateToken();

        let payload = {
          cartToken: cartResponse.token,
          sessionToken,
          currency: cartResponse.currency,
          totalValue: cartResponse.total_price,
          quantity: cartResponse.item_count,
        };
        sendCartToServer(payload);
      }
    } else if (cartResponse && cartResponse.id && cartResponse.final_price) {
      initSyncCart();
    }
  }
  function isPermissionGranted() {
    return Notification.permission === "granted";
  }
  function getCart() {
    return fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  async function initSyncCart() {
    if (isPermissionGranted()) {
      const cart = await getCart();
      if (cart.total_price > 0) {
        syncABC(cart);
      }
    }
  }

  function getPushHikeOptinCss(config) {
    const promptSettings = config.promptSettings;
    return `
   @keyframes show-up {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    #pushhike-optin-dialog {
      all: initial;
      display: block !important;
      z-index: 2147483647 !important;
      position: fixed !important;
      width: 420px !important;
      margin: 12px !important;
      box-sizing: border-box !important;
      background: rgb(255, 255, 255) !important;
      border-radius: 4px !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
      align-items: center !important;
      font-size: 14px !important;
      box-shadow: 0px 12px 13px rgba(0, 0, 0, 0.21) !important;

      top: 0 !important;
      left: 0 !important;

      animation-duration: 0.6s;
      animation-name: show-up;
    }
    .pushhike-optin-dialog * {
      width: initial !important;
      font-family: inherit !important;
      letter-spacing: initial !important;
      box-sizing: border-box !important;
      line-height: initial !important;
      font-weight: normal !important;
      -webkit-font-smoothing: initial !important;
      text-shadow: initial !important;
      border: initial !important;
      background: initial !important;
      padding: initial !important;
      text-align: initial !important;
      box-shadow: initial !important;
      min-width: initial !important;
      text-transform: initial !important;
    }
    .pushhike-optin-dialog svg {
      width: initial;
      height: initial;
      stroke: initial;
      fill: initial;
    }
    @media screen and (max-width: 444px) {
      .pushhike-optin-dialog {
        width: calc(100% - 24px) !important;

        top: 0 !important;
        bottom: auto !important;
        left: 0 !important;
      }
    }
    .pushhike-optin__content {
      padding: 16px !important;
    }
    .pushhike-optin__title {
      text-transform: initial !important;
      text-align: initial !important;
      letter-spacing: 0.3px !important;
      font-size: 16px !important;
      margin-top: 0 !important;
      margin-bottom: 8px !important;
      color: #343946 !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }
    .pushhike-optin__description {
      color: #637381 !important;
      margin: 0 !important;
      padding: 0 !important;
      font-size: inherit !important;
    }
    .pushhike-optin__image {
      border-radius: 50% !important;
      flex-shrink: 0 !important;
      margin-right: 16px !important;
      padding: 8px !important;
    }
    .pushhike-optin__image img {
      width: 40px !important;
    }
    .pushhike-optin-button {
      width: initial !important;
      min-width: initial !important;
      height: initial !important;
      min-height: initial !important;
      text-transform: initial !important;
      margin: initial !important;
      cursor: pointer !important;
      font-size: inherit !important;
      padding: 6px 20px !important;
      max-width: 150px !important;
      border-radius: 4px !important;
      border: none !important;
      white-space: nowrap !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
    }
    .pushhike-optin-yes-button {
      background: ${promptSettings.custom.colors.yesButtonBgColor} !important;
      color: ${promptSettings.custom.colors.yesButtonColor} !important;
    }
    .pushhike-optin-no-button {
      background: transparent !important;
      border: 0 !important;
      color: #637381 !important;
    }
    .pushhike-optin-footer {
      display: flex !important;
      justify-content: flex-end !important;
      align-items: center !important;
      margin-top: 16px !important;
    }
    .pushhike-optin-footer-btn-wrap {
      display: flex !important;
      align-items: center !important;
    }
    @media only screen and (max-width: 600px) {
      #pushhike-optin-dialog{
        width:320px !important;
       }
    }
  `;
  }

  function renderCustomPrompt(config) {
    const permission = Notification.permission;
    if (permission === "granted" || permission === "denied") {
      console.log(
        `user has already ${permission} for notification, popup not shown`
      );
      if (permission === "granted") {
        registerServiceWorker();
      }
      return;
    }

    console.log("config", config);
    pushhike_injectCss(getPushHikeOptinCss(config));
    const dialog = document.createElement("dialog");
    dialog.id = "pushhike-optin-dialog";
    const promptSettings = config.promptSettings;
    const html = `
    <div class="pushhike-optin__content">
      <div
        style="display: flex; align-items: flex-start"
        class="js-pushhike-title-desc-container"
        dir="auto"
      >
        <div style="flex: 1">
          <h2 class="js-pushhike-title pushhike-optin__title" tabindex="-1">
            ${promptSettings.custom.title}
          </h2>
          <p class="js-pushhike-description pushhike-optin__description">
            ${promptSettings.custom.description}
          </p>
        </div>
      </div>
      <div class="pushhike-optin-footer">
        <div
          class="pushhike-optin-footer-btn-wrap js-pushhike-btn-container"
          dir="auto"
        >
          <button
            class="pushhike-optin-button pushhike-optin-no-button"
            id="pushhike-no-button"
          >
            ${promptSettings.custom.noButton.label}
          </button>
          <button
            class="pushhike-optin-button pushhike-optin-yes-button"
            id="pushhike-yes-button"
          >
            ${promptSettings.custom.yesButton.label}
          </button>
        </div>
      </div>
    </div>`;
    dialog.innerHTML = html;
    const body = document.querySelector("body");
    body.appendChild(dialog);
    pushhikeYesButtonListener();
    pushhikeNoButtonListener();
  }

  function pushhikeYesButtonListener() {
    const button = document.querySelector("#pushhike-yes-button");
    button.addEventListener("click", pushhikeAllowNotificaition);
  }

  function pushhikeNoButtonListener() {
    const button = document.querySelector("#pushhike-no-button");
    button.addEventListener("click", pushhikeDenyNotification);
  }

  function pushhikeAllowNotificaition() {
    registerServiceWorker();
    removeDialog();
  }

  function pushhikeDenyNotification() {
    removeDialog();
  }

  function removeDialog() {
    const dialog = document.querySelector("#pushhike-optin-dialog");
    dialog.remove();
  }
})();
